module.exports = __webpack_public_path__ + "img/symbol_arrow1blue.bf64cfa6.png";